import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Stack,
  IconButton,
  TextField,
  Typography,
  Popover,
  Button,
  Tooltip,
  Container,
} from "@mui/material";
import { IoIosSend } from "react-icons/io";
import { AudioRecorder } from "react-audio-voice-recorder";
import { connect } from "react-redux";
import {
  CreateExternalDraftMessage,
  endInteraction,
  RemoveExternalDraftMessage,
  setcontactlist,
  setTypedMessage,
  setMessage,
  setTranslationLanguage,
} from "../../../../Redux/Actions/actions";
import { Trash, PlusCircle } from "@phosphor-icons/react";
import { MdAttachFile } from "react-icons/md";
import { BiMessage } from "react-icons/bi";
import { FiSmile } from "react-icons/fi";
import { styled } from "@mui/material/styles";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import axios from "axios";
import { toast } from "react-toastify";
import {
  BaseUrl,
  fileservice,
  fileSizeCofig,
  MsgSizeCofig,
  PortalUrl,
} from "../../../../Container/BaseUrl/BaseUrl";
import CannedMessage from "../chat-component-model/CannedMessage";
import PreViewmodal from "../chat-component-model/PreViewmodal";
import VoiceViewmodal from "../chat-component-model/VoiceViewmodal";
import { toaststyle } from "../../../../Utils/toaststyle";
// images
import noprewritten from "../../../../Assets/images/svg/Typing.svg";
import { useDebounce } from "../../../../Layout/Contacts/hooks";
import { BsTranslate } from "react-icons/bs";

const mapStateToProps = (state) => {
  return {
    chatid: state.data.chatid,
    chat: state.data.chat,
    externalChatData: state.contactListData.externalChatData,
    chatSessionId: state.contactListData.chatSessionId,
    typedMessage: state.chatReducer.typedMessage,
    message: state.chatReducer.message,
  };
};

const StyledInput = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-input": {
    fontSize: "13px",
    maxHeight: 200,
    padding: "10px",
    lineHeight: "14px !important",
    overflowY: "scroll !important",
    border: 0,
    scrollbarWidth: "none",
    "-ms-overflow-style": "none",
    "&::-webkit-scrollbar": {
      width: "0",
    },
  },
  "& .MuiInputBase-root": {
    padding: "5px",
  },
}));

const CoversationFooterExternal = (props) => {
  let permission = JSON.parse(localStorage.getItem("permission"));
  const { handleSendMsg, handleTyping } = props;
  const datas = JSON.parse(localStorage.getItem("tokenAgent"));
  const selectedChat = JSON.parse(localStorage.getItem("client"));
  const [showMessage, setShowMessage] = useState([]);
  const [showcannedmodal, setShowcannedmodal] = useState(false);
  const [showPreviewmodal, setshowPreviewmodal] = useState(false);
  const [showVoicePreviewModal, setshowVoicePreviewModal] = useState(false);
  const [uploadedFile, setuploadedFile] = useState();
  const [recorddata, setRecorddata] = useState("");
  const [recorderVoice, setrecorderVoice] = useState();
  const [openEmojiBox, setOpenEmojiBox] = useState(null);
  const Emojiopen = Boolean(openEmojiBox);
  const EmojiId = Emojiopen ? "simple-popover" : undefined;
  const [openCannedMsg, setOpenCannedMsg] = useState(null);
  const cannedMsgopen2 = Boolean(openCannedMsg);
  const cannedMsgId = cannedMsgopen2 ? "simple-popover" : undefined;
  const [openTranslate, setOpenTranslate] = useState(null);
  const translateOpen = Boolean(openTranslate);
  const translateId = translateOpen ? "translate-popover" : undefined;
  const [fromLanguage, setFromLanguage] = useState({ name: "English", code: "en" });
  const [toLanguage, setToLanguage] = useState({ name: "--", code: null });
  const [languageSearch, setLanguageSearch] = useState("");
  const [activeLanguageSelector, setActiveLanguageSelector] = useState("from"); // 'from' or 'to'
  const inputRef = useRef(null);
  const [cursorPosition, setcursorPosition] = useState();
  const debouncedSearch = useDebounce(props.typedMessage);

  // Language list for translation
  const languagesWithCodes = [
    { id: 1, name: "Abkhaz", code: "ab" },
    { id: 2, name: "Acehnese", code: null },
    { id: 3, name: "Acholi", code: null },
    { id: 4, name: "Afrikaans", code: "af" },
    { id: 5, name: "Albanian", code: "sq" },
    { id: 6, name: "Alur", code: null },
    { id: 7, name: "Amharic", code: "am" },
    { id: 8, name: "Arabic", code: "ar" },
    { id: 9, name: "Armenian", code: "hy" },
    { id: 10, name: "Assamese", code: "as" },
    { id: 11, name: "Awadhi", code: null },
    { id: 12, name: "Azerbaijani", code: "az" },
    { id: 13, name: "Balinese", code: null },
    { id: 14, name: "Baluchi", code: null },
    { id: 15, name: "Bambara", code: "bm" },
    { id: 16, name: "Bangla", code: "bn" },
    { id: 17, name: "Basque", code: "eu" },
    { id: 18, name: "Belarusian", code: "be" },
    { id: 19, name: "Bemba", code: null },
    { id: 20, name: "Bengali", code: "bn" },
    { id: 21, name: "Bhojpuri", code: null },
    { id: 22, name: "Bosnian", code: "bs" },
    { id: 23, name: "Bulgarian", code: "bg" },
    { id: 24, name: "Burmese", code: "my" },
    { id: 25, name: "Catalan", code: "ca" },
    { id: 26, name: "Cebuano", code: null },
    { id: 27, name: "Chinese (Simplified)", code: "zh" },
    { id: 28, name: "Chinese (Traditional)", code: "zh" },
    { id: 29, name: "Corsican", code: "co" },
    { id: 30, name: "Croatian", code: "hr" },
    { id: 31, name: "Czech", code: "cs" },
    { id: 32, name: "Danish", code: "da" },
    { id: 33, name: "Dinka", code: null },
    { id: 34, name: "Dutch", code: "nl" },
    { id: 35, name: "Dyula", code: null },
    { id: 36, name: "Dzongkha", code: "dz" },
    { id: 37, name: "English", code: "en" },
    { id: 38, name: "Esperanto", code: "eo" },
    { id: 39, name: "Estonian", code: "et" },
    { id: 40, name: "Ewe", code: "ee" },
    { id: 41, name: "Faroese", code: "fo" },
    { id: 42, name: "Fijian", code: "fj" },
    { id: 43, name: "Filipino", code: "tl" },
    { id: 44, name: "Finnish", code: "fi" },
    { id: 45, name: "French", code: "fr" },
    { id: 46, name: "Galician", code: "gl" },
    { id: 47, name: "Georgian", code: "ka" },
    { id: 48, name: "German", code: "de" },
    { id: 49, name: "Greek", code: "el" },
    { id: 50, name: "Guarani", code: "gn" },
    { id: 51, name: "Gujarati", code: "gu" },
    { id: 52, name: "Haitian Creole", code: "ht" },
    { id: 53, name: "Hausa", code: "ha" },
    { id: 54, name: "Hawaiian", code: null }, // no ISO-639-1
    { id: 55, name: "Hebrew", code: "he" },
    { id: 56, name: "Hindi", code: "hi" },
    { id: 57, name: "Hmong", code: null },
    { id: 58, name: "Hungarian", code: "hu" },
    { id: 59, name: "Icelandic", code: "is" },
    { id: 60, name: "Igbo", code: "ig" },
    { id: 61, name: "Indonesian", code: "id" },
    { id: 62, name: "Irish", code: "ga" },
    { id: 63, name: "Italian", code: "it" },
    { id: 64, name: "Japanese", code: "ja" },
    { id: 65, name: "Javanese", code: "jv" },
    { id: 66, name: "Kannada", code: "kn" },
    { id: 67, name: "Kazakh", code: "kk" },
    { id: 68, name: "Khmer", code: "km" },
    { id: 69, name: "Kinyarwanda", code: "rw" },
    { id: 70, name: "Korean", code: "ko" },
    { id: 71, name: "Kurdish", code: "ku" },
    { id: 72, name: "Kyrgyz", code: "ky" },
    { id: 73, name: "Lao", code: "lo" },
    { id: 74, name: "Latin", code: "la" },
    { id: 75, name: "Latvian", code: "lv" },
    { id: 76, name: "Lithuanian", code: "lt" },
    { id: 77, name: "Luxembourgish", code: "lb" },
    { id: 78, name: "Macedonian", code: "mk" },
    { id: 79, name: "Malagasy", code: "mg" },
    { id: 80, name: "Malay", code: "ms" },
    { id: 81, name: "Malayalam", code: "ml" },
    { id: 82, name: "Maltese", code: "mt" },
    { id: 83, name: "Maori", code: "mi" },
    { id: 84, name: "Marathi", code: "mr" },
    { id: 85, name: "Mongolian", code: "mn" },
    { id: 86, name: "Nepali", code: "ne" },
    { id: 87, name: "Norwegian", code: "no" },
    { id: 88, name: "Oriya", code: "or" },
    { id: 89, name: "Oromo", code: "om" },
    { id: 90, name: "Pashto", code: "ps" },
    { id: 91, name: "Persian", code: "fa" },
    { id: 92, name: "Polish", code: "pl" },
    { id: 93, name: "Portuguese", code: "pt" },
    { id: 94, name: "Punjabi", code: "pa" },
    { id: 95, name: "Romanian", code: "ro" },
    { id: 96, name: "Russian", code: "ru" },
    { id: 97, name: "Samoan", code: "sm" },
    { id: 98, name: "Sanskrit", code: null },
    { id: 99, name: "Serbian", code: "sr" },
    { id: 100, name: "Sesotho", code: "st" },
    { id: 101, name: "Shona", code: "sn" },
    { id: 102, name: "Sindhi", code: "sd" },
    { id: 103, name: "Sinhala", code: "si" },
    { id: 104, name: "Slovak", code: "sk" },
    { id: 105, name: "Slovenian", code: "sl" },
    { id: 106, name: "Somali", code: "so" },
    { id: 107, name: "Spanish", code: "es" },
    { id: 108, name: "Sundanese", code: "su" },
    { id: 109, name: "Swahili", code: "sw" },
    { id: 110, name: "Swedish", code: "sv" },
    { id: 111, name: "Tajik", code: "tg" },
    { id: 112, name: "Tamil", code: "ta" },
    { id: 113, name: "Tatar", code: null },
    { id: 114, name: "Telugu", code: "te" },
    { id: 115, name: "Thai", code: "th" },
    { id: 116, name: "Turkish", code: "tr" },
    { id: 117, name: "Turkmen", code: null },
    { id: 118, name: "Ukrainian", code: "uk" },
    { id: 119, name: "Urdu", code: "ur" },
    { id: 120, name: "Uyghur", code: null },
    { id: 121, name: "Uzbek", code: "uz" },
    { id: 122, name: "Vietnamese", code: "vi" },
    { id: 123, name: "Welsh", code: "cy" },
    { id: 124, name: "Xhosa", code: "xh" },
    { id: 125, name: "Yiddish", code: "yi" },
    { id: 126, name: "Yoruba", code: "yo" },
    { id: 127, name: "Zulu", code: "zu" },
  ];

  const filteredLanguages = languagesWithCodes.filter((lang) =>
    lang.name.toLowerCase().includes(languageSearch.toLowerCase())
  );

  // Translation API function
  const translateMessages = async (sourceLang, targetLang) => {
    try {
      // Validate both languages are selected
      if (!sourceLang.code || !targetLang.code) {
        toast.error("Please select both source and target languages", toaststyle);
        return;
      }

      const messages = props.message || [];
      const translatedMessages = await Promise.all(
        messages.map(async (msg) => {
          // Only translate text messages
          if (
            msg.msg_sent_type === "TEXT" ||
            (!msg.msg_sent_type && msg.message)
          ) {
            try {
              const response = await axios.post(
                PortalUrl + "/v1/purple/translateapi",
                {
                  content: msg.message,
                  sourceLanguage: sourceLang.code,
                  targetLanguage: targetLang.code,
                },
                {
                  headers: {
                    "Content-Type": "application/json",
                  },
                }
              );

              if (response.data.status && response.data.data.output) {
                return {
                  ...msg,
                  translatedMessage: response.data.data.output,
                  translatedLanguage: response.data.data.destinationLanguage,
                };
              }
            } catch (error) {
              console.error("Translation error for message:", error);
              return msg;
            }
          }
          return msg;
        })
      );

      // Update messages with translations
      props.setMessage(translatedMessages);
      toast.success(
        `Messages translated from ${sourceLang.name} to ${targetLang.name}`,
        toaststyle
      );
    } catch (error) {
      console.error("Translation API error:", error);
      toast.error("Translation failed. Please try again.", toaststyle);
    }
  };

  const onEmojiClick = (e) => {
    const ref = inputRef.current.children[0].children[0];
    const start = props.typedMessage.substring(0, ref.selectionStart);
    const end = props.typedMessage.substring(ref.selectionStart);
    const text = start + e.native + end;
    props.setTypedMessage(text);
    const newCursorPosition = start.length + e.native.length;
    setTimeout(() => {
      ref.focus();
      ref.setSelectionRange(newCursorPosition, newCursorPosition);
    }, 10);
    setOpenEmojiBox(null);
  };
  const onCannedMsg = (value) => {
    const ref = inputRef.current.children[0].children[0];
    const start = props.typedMessage.substring(0, ref.selectionStart);
    const end = props.typedMessage.substring(ref.selectionStart);
    const text = start + value + end;
    props.setTypedMessage(text);
    const newCursorPosition = start.length + value.length;
    setTimeout(() => {
      ref.focus();
      ref.setSelectionRange(newCursorPosition, newCursorPosition);
    }, 0);

    setOpenCannedMsg(null);
  };

  useEffect(() => {
    const images = document.querySelectorAll("img");
    images.forEach((image) => {
      image.removeAttribute("title");
    });
  }, []);

  const sendMessage = async (event) => {
    if (
      (event.key === "Enter" && !event.shiftKey) ||
      event._reactName === "onClick"
    ) {
      event.preventDefault();
      if (recorddata) {
        const data = JSON.parse(localStorage.getItem("client"));
        let formData = new FormData();
        if (recorddata.size <= fileSizeCofig) {
          return toast.error("File Too Large", toaststyle);
        }

        const selectedChat = JSON.parse(localStorage.getItem("client"));
        let fileUploaded = recorddata;
        let fileName = "audio.wav";
        let file = new File([fileUploaded], fileName);
        formData.append("file", file, fileName);
        formData.append("userID", selectedChat.unique_id.phonenumber);
        formData.append("clientApp", "InapiWebchat");
        formData.append("channel", "webchat");
        formData.append("sessionId", data.chat_session_id);
        formData.append("sentBy", "Agent");
        await axios
          .post(fileservice + "/fileServer/uploadMedia", formData, {
            headers: {
              "content-type": "multipart/form-data",
              tenantId: "123456",
            },
          })
          .then((response) => {
            // console.log("audio_url", audio_url);
            if (response.data.status) {
              let audio_url = response.data.data.signedUrl;
              handleSendMsg(audio_url, "AUDIO", "");
              setshowVoicePreviewModal(false);
              setRecorddata(null);
            }
          })
          .catch((error) => {
            console.log("send msg", error);
            toast.error(
              "Sorry,the file you are trying to upload is too big(maximum size is 3072KB)",
              toaststyle
            );
          });
      } else {
        const trimmedMessage = props.typedMessage.trim();
        if (trimmedMessage.length === 0) return;
        if (trimmedMessage.length >= MsgSizeCofig)
          return toast.error(
            "More than 3000 Characters Not Allowed",
            toaststyle
          );
        handleSendMsg(trimmedMessage, "TEXT", "");
        props.RemoveExternalDraftMessage(selectedChat);
        props.setTypedMessage("");
        inputRef.current.focus();
      }
    } else if (event.key === "Enter" && event.shiftKey) {
      event.preventDefault();
      props.setTypedMessage(props.typedMessage + "\n");
    } else if (event.key === "Enter" && event.altKey) {
      event.preventDefault();
      props.setTypedMessage(props.typedMessage + "\n");
    }

    if (inputRef.current.children[0].children[1]) {
      inputRef.current.children[0].children[1].scrollTop =
        inputRef.current.children[0].children[1].scrollHeight;
    }
  };
  const addAudioElement = (blob) => {
    setRecorddata(blob);
    const url = URL.createObjectURL(blob);
    setrecorderVoice(url);
    setshowVoicePreviewModal(true);
  };
  const retrieveScannedMsg = () => {
    let data = {
      offset: "0",
      limit: "200",
      agent_id: datas.agent_id,
    };
    axios
      .post(BaseUrl + "/scannedMessage/listMessage", data, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        if (res.data.status == true) {
          setShowMessage(res.data.data);
        } else {
          setShowMessage([]);
        }
      })
      .catch((error) => {});
  };
  const deleteScannedMessage = (id) => {
    let data = {
      id: id,
    };
    axios
      .post(BaseUrl + "/scannedMessage/deleteScannedMessage", data, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        if (res.status) {
          retrieveScannedMsg();
          toast.success("Canned Message Deleted", toaststyle);
        }
      })
      .catch((error) => {});
  };
  const sendFile = () => {
    if (!uploadedFile) return toast.error("Something Went Wrong", toaststyle);
    handleSendMsg(
      uploadedFile.attachmentUrl,
      uploadedFile.fileType,
      uploadedFile.filename
    );
  };
  useEffect(() => {
    inputRef.current.children[0].children[1].selectionEnd = cursorPosition;
  }, [cursorPosition]);

  useEffect(() => {
    props.CreateExternalDraftMessage(selectedChat, props.typedMessage);
  }, [debouncedSearch]);

  return (
    <>
      <Box
        sx={{
          height: "auto",
          backgroundColor: "#FFFF",
          maxHeight: 260,
          borderRadius: "0 0 7px 0",
          boxShadow:
            "rgba(50, 50, 93, 0.25) 1px -2px 4px -1px, rgba(0, 0, 0, 0.3) 0px 0px 1px -1px",
          zIndex: "999",
        }}
      >
        <Stack
          direction={"column"}
          alignItems={"center"}
          spacing={1}
          className="w-100 p-1"
        >
          <Stack className="w-100 sendMess p-1">
            <StyledInput
              dir={
                props.externalChatData
                  ? props.externalChatData.language == "Arabic"
                    ? "rtl"
                    : ""
                  : ""
              }
              className="CONTACT-LIST-AREA"
              fullWidth
              multiline
              placeholder="Type a message"
              value={props.typedMessage}
              onChange={(e) => {
                inputRef.current.children[0].children[1].scrollTop =
                  inputRef.current.children[0].children[1].scrollHeight;
                props.setTypedMessage(`${e.target.value}`);
                handleTyping();
              }}
              ref={inputRef}
              onKeyDown={sendMessage}
              variant="filled"
            />

            <Stack
              className="px-1 w-100"
              direction={"row"}
              alignItems={"center"}
              justifyContent={"Right"}
            >
              <Stack
                className="col-9"
                direction={"row"}
                alignContent={"center"}
                alignItems={"center"}
              >
                {permission.map((module) => {
                  if (module.moduleName === "CHAT_INTERACTION") {
                    const value = module.screen.find(
                      (item) =>
                        item.screenId === "SCANNED_MESSAGE" &&
                        item.read &&
                        item.write
                    );

                    if (value) {
                      return (
                        <Tooltip title="Canned Message">
                          <IconButton
                            aria-label="canned"
                            size="small"
                            className="me-1"
                            aria-describedby={cannedMsgId}
                            onClick={(e) => {
                              retrieveScannedMsg();
                              setOpenCannedMsg(e.currentTarget);
                            }}
                          >
                            <BiMessage />
                          </IconButton>
                        </Tooltip>
                      );
                    } else {
                      return (
                        <Tooltip title="Contact Admin">
                          <IconButton
                            aria-label="canned"
                            size="small"
                            className="me-1"
                          >
                            <BiMessage />
                          </IconButton>
                        </Tooltip>
                      );
                    }
                  }
                })}

                {/* canned popover  */}
                <Popover
                  sx={{
                    "& .MuiPaper-root": {
                      borderRadius: "7px",
                      height: "300px",
                      width: "300px",
                      boxShadow:
                        "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
                      scrollbarWidth: "none",
                      "-ms-overflow-style": "none",
                      "&::-webkit-scrollbar": {
                        width: "0",
                      },
                    },
                  }}
                  id={cannedMsgId}
                  open={cannedMsgopen2}
                  anchorEl={openCannedMsg}
                  onClose={() => {
                    setOpenCannedMsg(null);
                  }}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                  transformOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                >
                  <Box
                    sx={{
                      gap: "10px",
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                      width: "100%",
                    }}
                  >
                    <Box
                      className="border-bottom"
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        padding: "5px 10px",
                        alignItems: "center",
                        height: "50px",
                        width: "100%",
                        boxShadow:
                          "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 600,
                          fontSize: "14px",
                          color: "#0b3363",
                        }}
                      >
                        Canned Message
                      </Typography>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setShowcannedmodal(true);
                        }}
                      >
                        <PlusCircle size={18} weight="bold" />
                      </IconButton>
                    </Box>

                    <div
                      className="card-body canned_card CONTACT-LIST-AREA"
                      style={{
                        height: "calc(100% - 40px)",
                        padding: "5px",
                        overflowY: "scroll",
                      }}
                    >
                      <Stack sx={{ width: "100%" }}>
                        {showMessage.length > 0 ? (
                          showMessage.map((item, index) => (
                            <Container maxWidth="sm">
                              <div
                                className="row border-bottom justify-content-center align-items-center bg-white hover-overlay py-2"
                                style={{ cursor: "pointer" }}
                                key={index}
                                onClick={() => {
                                  onCannedMsg(item.message);
                                }}
                              >
                                <Stack
                                  direction={"row"}
                                  alignItems={"center"}
                                  justifyContent={"space-between"}
                                  sx={{ padding: "0" }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    sx={{ fontSize: "12px", width: "180px" }}
                                    noWrap
                                  >
                                    {item.message}
                                  </Typography>

                                  <IconButton
                                    onClick={() => {
                                      deleteScannedMessage(item.id);
                                    }}
                                    color="error"
                                    size="small"
                                  >
                                    <Trash size={13} />
                                  </IconButton>
                                </Stack>
                              </div>
                            </Container>
                          ))
                        ) : (
                          // No pre-written  replies
                          <div className="d-flex justify-content-center align-items-center h-100 text-muted flex-column">
                            <img
                              src={noprewritten}
                              alt=""
                              srcset=""
                              width={180}
                            />
                            <div className="fs-13">No pre-written replies</div>
                          </div>
                        )}
                      </Stack>
                    </div>
                  </Box>
                </Popover>

                {/* Attachment */}
                {permission.map((module) => {
                  if (module.moduleName === "CHAT_INTERACTION") {
                    const value = module.screen.find(
                      (item) =>
                        item.screenId === "ATTACH_FILE" &&
                        item.read &&
                        item.write
                    );

                    if (value) {
                      return (
                        <Tooltip title="Attach file">
                          <IconButton
                            aria-label="attach"
                            size="small"
                            className="me-1"
                            onClick={() => {
                              setshowPreviewmodal(true);
                            }}
                          >
                            <MdAttachFile />
                          </IconButton>
                        </Tooltip>
                      );
                    } else {
                      return (
                        <Tooltip title="Contact Admin">
                          <IconButton
                            aria-label="attach"
                            size="small"
                            className="me-1"
                          >
                            <MdAttachFile />
                          </IconButton>
                        </Tooltip>
                      );
                    }
                  }
                })}
                {/* translate */}
                {permission.map((module) => {
                  if (module.moduleName === "CHAT_INTERACTION") {
                    const value = module.screen.find(
                      (item) =>
                        item.screenId === "CHAT_TRANSLATE" &&
                        item.read &&
                        item.write
                    );

                    if (value) {
                      return (
                        <Tooltip title="Translate">
                          <IconButton
                            aria-label="translate"
                            size="small"
                            aria-describedby={translateId}
                            onClick={(e) => {
                              setOpenTranslate(e.currentTarget);
                            }}
                          >
                            <BsTranslate />
                          </IconButton>
                        </Tooltip>
                      );
                    } else {
                      return null;
                    }
                  }
                })}
                {/* emoji */}
                {permission.map((module) => {
                  if (module.moduleName === "CHAT_INTERACTION") {
                    const value = module.screen.find(
                      (item) =>
                        item.screenId === "EMOJI" && item.read && item.write
                    );

                    if (value) {
                      return (
                        <Tooltip title="Emoji">
                          <IconButton
                            aria-label="smile"
                            size="small"
                            aria-describedby={EmojiId}
                            onClick={(e) => {
                              setOpenEmojiBox(e.currentTarget);
                            }}
                          >
                            <FiSmile />
                          </IconButton>
                        </Tooltip>
                      );
                    } else {
                      return (
                        <Tooltip title="Contact Admin">
                          <IconButton aria-label="smile" size="small">
                            <FiSmile />
                          </IconButton>
                        </Tooltip>
                      );
                    }
                  }
                })}

                {props.externalChatData ? (
                  props.externalChatData.channel == "webchat" ? (
                    <Box className="position-relative">
                      {permission.map((module) => {
                        if (module.moduleName === "CHAT_INTERACTION") {
                          const value = module.screen.find(
                            (item) =>
                              item.screenId === "VOICE_RECORD_CHAT" ||
                              item.screenId === "VOICE_RECORD_WHATSAPP" ||
                              (item.screenId === "VOICE_RECORD_PURPLE" &&
                                item.read &&
                                item.write)
                          );

                          if (value) {
                            return (
                              <AudioRecorder
                                onRecordingComplete={addAudioElement}
                                audioTrackConstraints={{
                                  noiseSuppression: true,
                                  echoCancellation: true,
                                }}
                                mediaRecorderOptions={{
                                  audioBitsPerSecond: 128000,
                                }}
                                showVisualizer={true}
                                title={false}
                              />
                            );
                          } else {
                            return <AudioRecorder title={false} />;
                          }
                        }
                      })}
                    </Box>
                  ) : (
                    <></>
                  )
                ) : (
                  <></>
                )}
              </Stack>

              <Stack className="col-3" alignItems={"end"}>
                <Button
                  size="small"
                  variant="contained"
                  disableElevation
                  onClick={sendMessage}
                >
                  <IoIosSend className="me-2" />
                  Send
                </Button>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Box>

      {showcannedmodal && (
        <CannedMessage
          showcannedmodal={showcannedmodal}
          handleClose={() => {
            setShowcannedmodal(false);
          }}
          retrieveScannedMsg={retrieveScannedMsg}
        />
      )}

      {showPreviewmodal && (
        <PreViewmodal
          showPreviewmodal={showPreviewmodal}
          uploadedFile={uploadedFile}
          sendMessage={sendFile}
          UploadFrom={""}
          setuploadedFile={setuploadedFile}
          handleClose={() => {
            setshowPreviewmodal(false);
            setuploadedFile(null);
          }}
        />
      )}

      {showVoicePreviewModal && (
        <VoiceViewmodal
          showVoicePreviewModal={showVoicePreviewModal}
          handleClose={() => {
            setshowVoicePreviewModal(false);
            setRecorddata("");
            setrecorderVoice("");
          }}
          sendMessage={sendMessage}
          recorderVoice={recorderVoice}
        />
      )}

      <Popover
        sx={{
          "& .MuiPaper-root": {
            background: "red",
            borderRadius: "13px",
            height: "310px",
            top: "220px !important",
            left: "930px !important",
            scrollbarWidth: "none",
            "-ms-overflow-style": "none",
            "&::-webkit-scrollbar": {
              width: "0",
            },
          },
        }}
        id={EmojiId}
        open={Emojiopen}
        anchorEl={openEmojiBox}
        onClose={() => {
          setOpenEmojiBox(null);
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Picker
          data={data}
          onEmojiSelect={onEmojiClick}
          theme={"light"}
          perLine={7}
        />
      </Popover>

      {/* Translate Language Selector Popover */}
      <Popover
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "8px",
            width: "350px",
            maxHeight: "500px",
            boxShadow:
              "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
          },
        }}
        id={translateId}
        open={translateOpen}
        anchorEl={openTranslate}
        onClose={() => {
          setOpenTranslate(null);
          setLanguageSearch("");
          setActiveLanguageSelector("from");
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100%",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              padding: "10px 15px",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "14px",
                color: "#0b3363",
                marginBottom: "8px",
              }}
            >
              Translate Messages
            </Typography>

            {/* Tab Selector */}
            <Stack direction="row" spacing={1} sx={{ marginBottom: "8px" }}>
              <Button
                size="small"
                variant={activeLanguageSelector === "from" ? "contained" : "outlined"}
                onClick={() => {
                  setActiveLanguageSelector("from");
                  setLanguageSearch("");
                }}
                sx={{
                  flex: 1,
                  fontSize: "12px",
                  textTransform: "none",
                }}
              >
                From: {fromLanguage.name}
              </Button>
              <Button
                size="small"
                variant={activeLanguageSelector === "to" ? "contained" : "outlined"}
                onClick={() => {
                  setActiveLanguageSelector("to");
                  setLanguageSearch("");
                }}
                sx={{
                  flex: 1,
                  fontSize: "12px",
                  textTransform: "none",
                }}
              >
                To: {toLanguage.name}
              </Button>
            </Stack>

            {/* Search Input */}
            <TextField
              fullWidth
              size="small"
              placeholder={`Search ${activeLanguageSelector === "from" ? "source" : "target"} language...`}
              value={languageSearch}
              onChange={(e) => setLanguageSearch(e.target.value)}
              sx={{
                "& .MuiInputBase-input": {
                  fontSize: "13px",
                  padding: "8px",
                },
              }}
            />
          </Box>

          {/* Language List */}
          <Box
            className="CONTACT-LIST-AREA"
            sx={{
              maxHeight: "250px",
              overflowY: "auto",
              padding: "5px 0",
            }}
          >
            {filteredLanguages.length > 0 ? (
              filteredLanguages.map((language, index) => (
                <Box
                  key={index}
                  onClick={() => {
                    if (language.code) {
                      if (activeLanguageSelector === "from") {
                        setFromLanguage(language);
                      } else {
                        setToLanguage(language);
                      }
                      setLanguageSearch("");
                    } else {
                      toast.error(
                        `${language.name} is not supported for translation`,
                        toaststyle
                      );
                    }
                  }}
                  sx={{
                    padding: "10px 15px",
                    cursor: "pointer",
                    backgroundColor:
                      (activeLanguageSelector === "from" && fromLanguage.name === language.name) ||
                      (activeLanguageSelector === "to" && toLanguage.name === language.name)
                        ? "#e3f2fd"
                        : "transparent",
                    "&:hover": {
                      backgroundColor: "#f5f5f5",
                    },
                    transition: "background-color 0.2s",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "13px",
                      fontWeight:
                        (activeLanguageSelector === "from" && fromLanguage.name === language.name) ||
                        (activeLanguageSelector === "to" && toLanguage.name === language.name)
                          ? 600
                          : 400,
                      color:
                        (activeLanguageSelector === "from" && fromLanguage.name === language.name) ||
                        (activeLanguageSelector === "to" && toLanguage.name === language.name)
                          ? "#1976d2"
                          : "#333",
                    }}
                  >
                    {language.name}
                  </Typography>
                </Box>
              ))
            ) : (
              <Box
                sx={{
                  padding: "20px",
                  textAlign: "center",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "13px",
                    color: "#999",
                  }}
                >
                  No languages found
                </Typography>
              </Box>
            )}
          </Box>

          {/* Footer - Translation Direction Display & Action Button */}
          <Box
            sx={{
              padding: "10px 15px",
              borderTop: "1px solid #e0e0e0",
              backgroundColor: "#f9f9f9",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                marginBottom: "10px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "13px",
                  fontWeight: 600,
                  color: "#1976d2",
                }}
              >
                {fromLanguage.name}
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#666",
                }}
              >
                →
              </Typography>
              <Typography
                sx={{
                  fontSize: "13px",
                  fontWeight: 600,
                  color: "#1976d2",
                }}
              >
                {toLanguage.name}
              </Typography>
            </Box>

            {/* Translate Button */}
            <Button
              fullWidth
              variant="contained"
              size="small"
              onClick={async () => {
                // Save translation language to Redux
                props.setTranslationLanguage(toLanguage);
                // Call translation API for existing messages
                await translateMessages(fromLanguage, toLanguage);
                setOpenTranslate(null);
                setLanguageSearch("");
                setActiveLanguageSelector("from");
              }}
              disabled={!fromLanguage.code || !toLanguage.code}
              sx={{
                textTransform: "none",
                fontSize: "13px",
              }}
            >
              Translate Messages
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default connect(mapStateToProps, {
  endInteraction,
  setcontactlist,
  CreateExternalDraftMessage,
  RemoveExternalDraftMessage,
  setTypedMessage,
  setMessage,
  setTranslationLanguage,
})(CoversationFooterExternal);
